<template>
  <q-page padding>
    <PageHeader
      title="Listagem Centros de Custo"
      :backRoute="{ name: 'home' }"
      backBehavior="route"
    />

    <div
      class="row col-12 q-mt-md text-brand-5 q-gutter-sm text-weight-bold container-inputs"
    >
      <div class="col-md-2 col-sm-5 col-xs-5">
        <div class="q-ml-sm titulo-input">Unidade</div>

        <lista-unidades-select
          class="input-new-design"
          v-model="recebeUnidade.unidade"
        ></lista-unidades-select>
      </div>
      <div class="col-md-2 col-sm-6 col-xs-6">
        <div class="q-ml-sm titulo-input">Código</div>
        <q-input
          label="Digite o código"
          class="input input-new-design"
          v-model="dados.codigo"
          dense
          outlined
        />
      </div>
      <div class="col-md-2 col-sm-4 col-xs-4">
        <div class="q-ml-sm titulo-input">Descrição (Setor)</div>
        <q-input
          label="Digite o setor"
          class="input input-new-design"
          v-model="dados.descricao"
          dense
          outlined
        />
      </div>
      <div class="col-md-2 col-sm-4 col-xs-4">
        <div class="q-ml-sm titulo-input">Conta</div>
        <q-input
          label="Digite a conta"
          class="input input-new-design"
          v-model="dados.conta"
          dense
          outlined
        />
      </div>
      <div>
        <p></p>
        <q-btn
          class="q-mt-sm btn"
          label="Criar Centro de Custo"
          icon="add"
          style="
            background-color: #21324a;
            border-radius: 8px;
            color: white;
            font-weight: normal;
          "
          no-caps
          @click="criarCentroDeCusto()"
        />
      </div>
    </div>
    <div class="q-mt-xl">
      <q-table
        :columns="columns"
        :rows="listaCentroDeCustos"
        color="primary"
        dense
        :loading="loading"
        class="tabela-tamanho-fixo"
        table-header-class="bg-accent text-weight-bold"
        flat
        :grid="$q.screen.lt.sm"
        hide-pagination
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-right>
          <q-input
            rounded
            outlined
            class="col-md-3 col-xs-12"
            dense
            debounce="300"
            v-model="busca"
            type="text"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Todos os Centro de Custos Criados</span
          >
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5">
              <div class="row col-12 items-center justify-between">
                <div class="row col-12">
                  <span class="q-ml-sm q-mt-sm"
                    ><strong>ID: </strong>{{ props.row.id }}</span
                  >
                </div>
                <div class="row col-12">
                  <span class="q-ml-sm"
                    ><strong>Código: </strong>{{ props.row.code }}</span
                  >
                </div>
                <span class="row col-12 q-ml-sm"
                  ><strong>Nome: </strong>{{ props.row.name }}</span
                >
                <div class="col-12 q-mt-sm">
                  <div class="text-brand-5 btn-grid-container">
                    <div class="row">
                      <div class="column col-6">
                        <q-btn
                          no-caps
                          stack
                          color="blue-6"
                          class="btn-grid-esquerdo"
                          icon="article"
                          @click="detalharCentroDeCusto(props.row.id)"
                        />
                      </div>
                      <div class="column col-6">
                        <q-btn
                          no-caps
                          stack
                          color="red"
                          label="Deletar"
                          class="btn-grid-direito"
                          icon="delete"
                          @click="receberId(props.row.id), (confirm = true)"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:body-cell-id="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.id }}
          </q-td>
        </template>
        <template v-slot:body-cell-codigo="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.code }}
          </q-td>
        </template>
        <template v-slot:body-cell-nome="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            {{ props.row.name }}
          </q-td>
        </template>
        <template v-slot:body-cell-indexar="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-btn
              dense
              icon="sym_o_sync"
              flat
              color="positive"
              round
              @click="indexar(props.row.id)"
            />
          </q-td>
        </template>

        <template v-slot:body-cell-detalhe="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <router-link
              :to="{
                name: 'centrodecusto-detalhe',
                params: { centroCustoId: props.row.id },
              }"
            >
              <q-btn round size="md" flat icon="sym_o_article" color="blue-6" />
            </router-link>
          </q-td>
        </template>
        <template v-slot:body-cell-regra="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <router-link
              :to="{
                name: 'centrodecusto-regra',
                params: { id: props.row.id },
              }"
            >
              <q-btn
                round
                size="md"
                flat
                icon="sym_o_design_services"
                color="brand-1"
              />
            </router-link>
          </q-td>
        </template>

        <template v-slot:body-cell-deletar="props">
          <q-td class="text-brand-5 text-weight-bold" :props="props">
            <q-btn
              dense
              icon="sym_o_delete"
              flat
              color="red"
              round
              @click="receberId(props.row.id), (confirm = true)"
            />
          </q-td>
        </template>
      </q-table>
      <div v-if="columns.length != 0" class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>
    <q-dialog v-model="confirm" persistent>
      <q-card class="q-pa-sm text-brand-5 text-weight-bolder">
        <q-card-section class="row items-center">
          <span class="q-ml-sm"
            >Você tem certeza que deseja remover esse centro de custo?</span
          >
        </q-card-section>

        <q-card-actions align="right">
          <q-btn
            icon="cancel"
            no-caps
            dense
            outline
            label="Não"
            color="negative"
            v-close-popup
          />
          <q-btn
            no-caps
            dense
            outline
            label="Sim"
            color="positive"
            v-close-popup
            icon="check_circle_outline"
            @click="deletarCentroDeCusto()"
          />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
import { onMounted, ref, watch, computed } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import PageHeader from "../../../components/PageHeader.vue";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
    field: "id",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
    field: "code",
  },
  {
    name: "nome",
    label: "Nome",
    align: "left",
    field: "name",
  },
  {
    name: "detalhe",
    label: "Detalhe",
    align: "center",
  },
  {
    name: "regra",
    label: "Regra",
    align: "center",
  },
  {
    name: "indexar",
    label: "Indexar",
    align: "center",
  },
  {
    name: "deletar",
    label: "Deletar",
    align: "center",
  },
];
export default {
  components: { ListaUnidadesSelect, PageHeader },
  setup() {
    const store = useStore();
    const quasar = useQuasar();
    const router = useRouter();

    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData,
      id: store.state.org.unidadeData.id,
    });
    const listaCentroDeCustos = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 6,
      rowsNumber: 6,
    });
    let disable = ref(false);
    let loading = ref(false);
    let confirm = ref(false);
    const busca = ref("");
    const dados = ref({
      codigo: "",
      descricao: "",
      conta: "",
    });
    let centroDeCustoId = ref();

    const listarCentrosDeCustos = async (page = 0, rowsNumber = 6) => {
      disable.value = true;
      try {
        loading.value = true;
        await recebeUnidade.value.id;
        const response = await store.dispatch(
          "centroDeCusto/listarCentroDeCustos",
          {
            per_page: rowsNumber,
            page: page,
            vendor_id: recebeUnidade.value.id,
            search: busca.value,
          }
        );
        listaCentroDeCustos.value = response.data.results.data;
        pagination.value.rowsPerPage = response.data.results.per_page;
        pagination.value.page = response.data.results.current_page;
        pagination.value.rowsNumber = response.data.results.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const criarCentroDeCusto = async () => {
      if (dados.value.codigo == "" || dados.value.descricao == "") {
        quasar.notify({
          message: "Os campos código e descrição não podem ser vazios.",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      try {
        await store.dispatch("centroDeCusto/criarCentroDeCusto", {
          code: dados.value.codigo,
          name: dados.value.descricao,
          conta: dados.value.conta,
          vendor_id: recebeUnidade.value.id,
        });
        reset();
        listarCentrosDeCustos();
        quasar.notify({
          message: "Centro de Custo criado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        let mensagem = "Erro ao criar Centro de Custo";
        if (error.response.data.message) {
          mensagem = error.response.data.message;
        }
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const detalharCentroDeCusto = async (id) => {
      router.push({
        name: "centrodecusto-detalhe",
        params: { centroCustoId: id },
      });
    };

    const reset = async () => {
      dados.value = {
        codigo: "",
        descricao: "",
        conta: "",
      };
    };

    const receberId = async (id) => {
      centroDeCustoId.value = id;
    };

    const deletarCentroDeCusto = async () => {
      try {
        await store.dispatch("centroDeCusto/deletarCentroDeCusto", {
          cost_center_id: centroDeCustoId.value,
        });
        listarCentrosDeCustos();
        quasar.notify({
          message: "Centro de Custo deletado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        let mensagem = "Erro ao deletar Centro de Custo";
        if (error.response.data.message) {
          mensagem = error.response.data.message;
        }
        quasar.notify({
          message: mensagem,
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const indexar = async (id) => {
      try {
        await store.dispatch("centroDeCusto/indexar", {
          centrosDeCusto: [id],
        });
        listarCentrosDeCustos();
        quasar.notify({
          message:
            "Job de re-indexação disparado, as atualizações serão feitas em background",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        quasar.notify({
          message: "Erro a o indexar Centro de Custo",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const paginarTabela = async () => {
      listarCentrosDeCustos(
        pagination.value.page,
        pagination.value.rowsPerPage
      );
    };

    watch(
      () => pagination.value.page,
      () => {
        listarCentrosDeCustos(
          pagination.value.page,
          pagination.value.rowsPerPage
        );
      }
    );

    watch(
      () => store.state.org.unidadeData,
      () => {
        recebeUnidade.value.unidade = store.state.org.unidadeData;
        recebeUnidade.value.id = store.state.org.unidadeData.id;
        listarCentrosDeCustos();
      }
    );

    watch(
      () => busca.value,
      () => {
        listarCentrosDeCustos();
      }
    );

    onMounted(listarCentrosDeCustos);

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        recebeUnidade.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    return {
      recebeUnidade,
      columns,
      listarCentrosDeCustos,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      disable,
      loading,
      paginarTabela,
      listaCentroDeCustos,
      busca,
      dados,
      criarCentroDeCusto,
      reset,
      deletarCentroDeCusto,
      confirm,
      receberId,
      centroDeCustoId,
      detalharCentroDeCusto,
      indexar,
    };
  },
};
</script>

<style scoped>
a {
  text-decoration: none;
}
@media (max-width: 600px) {
  .texto-titulo {
    font-size: 14px;
    margin-top: 10px;
  }
  .container-inputs {
    margin: 0px 0px 0px 0px;
  }
  .titulo-input {
    font-size: 12px;
    margin: 0px;
  }
  .btn {
    margin: 6px 0px 0px 0px;
  }
  .input {
    font-size: 12px;
  }
  .texto-titulo-tabela {
    margin: 0px 0px 0px 6px;
    font-size: 14px;
  }
  .container-input-search {
    margin: 17px 0px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .btn-grid-esquerdo {
    border-radius: 0px 0px 0px 5px;
    font-size: 12px;
  }
  .btn-grid-direito {
    border-radius: 0px 0px 5px 0px;
    font-size: 12px;
  }
  .text-grid-table {
    font-size: 12px;
  }
}
</style>
<style>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}

.titulo-input {
  color: #213864;
}
</style>
